import { Reveal, MaskedLines, Eyebrow } from "@/components/Motion";

const PageHero = ({ eyebrow, lines, description, image, children }) => (
  <section className="relative overflow-hidden bg-obsidian pb-20 pt-40 lg:pb-28 lg:pt-52" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-obsidian/60 via-obsidian/85 to-obsidian" />
      </>
    )}
    <div className="absolute -right-32 top-24 h-80 w-80 rounded-full bg-emerald-500/[0.07] blur-[110px]" />
    <div className="nx-container relative">
      <Reveal delay={0.1}>
        <Eyebrow>{eyebrow}</Eyebrow>
      </Reveal>
      <h1 className="mt-6 max-w-5xl font-heading text-4xl font-light leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <MaskedLines lines={lines} onLoad delay={0.25} />
      </h1>
      {description && (
        <Reveal delay={0.6}>
          <p className="mt-7 max-w-2xl text-base leading-relaxed text-white/60 lg:text-lg">{description}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);

export default PageHero;
